import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

const badgeVariants = cva(
  'inline-flex items-center gap-1 rounded-full px-2 py-0.5 font-mono text-[11px] font-medium tracking-tight',
  {
    variants: {
      variant: {
        default: 'bg-muted text-muted-foreground',
        accent: 'bg-accent-soft text-accent',
        warn: 'bg-warn/15 text-warn',
        destructive: 'bg-destructive/12 text-destructive',
        ok: 'bg-ok/12 text-ok',
      },
    },
    defaultVariants: { variant: 'default' },
  },
);

export function Badge({
  className,
  variant,
  ...props
}: React.HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>): JSX.Element {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}
